import { animate, state, style, transition, trigger } from "@angular/animations";
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChildren, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, inject } from "@angular/core";
import { AccordionItemDirective } from "./directives/accordion-item.directive";
import { NgTemplateOutlet } from "@angular/common";
import { TogglePipe } from "./pipe/toggle.pipe";

@Component({
    selector: "app-accordion",
    templateUrl: "./accordion.component.html",
    styleUrls: ["./accordion.component.css"],
    changeDetection: ChangeDetectionStrategy.Default,
    animations: [
        trigger('contentExpansion', [
            state('expanded', style({ height: '*', opacity: 1, visibility: 'visible' })),
            state('collapsed', style({ height: '0px', opacity: 0, visibility: 'hidden' })),
            transition('expanded <=> collapsed', animate('200ms cubic-bezier(.37,1.04,.68,.98)')),
        ])
    ],
    imports: [NgTemplateOutlet, TogglePipe]
})
export class AccordionComponent implements OnChanges, AfterViewInit {
    private static nextId = 0;
    private cdr = inject(ChangeDetectorRef);
    private readonly id = `accordion-${AccordionComponent.nextId++}`;

    expanded = new Set<number>();
    /**
     * Decides if the single item will be open at once or not.
     * In collapsing mode, toggling one would collapse others
     */
    @Input() collapsing = true;
    @Input() initialExpandedIndex: number;

    @Output() expandedByIndex = new EventEmitter<number>();
    @Output() collapsedByIndex = new EventEmitter<number>();
    @Output() onAccordionExpansionFinished = new EventEmitter<{e, i}>();


    @ContentChildren(AccordionItemDirective) items: QueryList<AccordionItemDirective>;

    ngAfterViewInit(): void {
        if (this.initialExpandedIndex > -1) {
            this.toggleState(this.initialExpandedIndex);
        }
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items) {
            if (changes.items.currentValue.length != changes.items.previousValue.length) {
                this.expanded.clear();
                this.cdr.markForCheck();
            }
        }
    }

    toggleState = (index: number) => {
        if (this.expanded.has(index)) {
            this.collapsedByIndex.emit(index);
            this.expanded.delete(index);
        } else {
            if (this.collapsing) {
                this.expanded.clear();
            }
            this.expandedByIndex.emit(index);
            this.expanded.add(index);
        }
        this.cdr.markForCheck();
    };

    contentId(index: number): string {
        return `${this.id}-content-${index}`;
    }

    emitContentExpanded(event: any, index: number){
        if(event.toState == 'expanded'){
            this.onAccordionExpansionFinished.emit({e: event, i: index});
        }
    }

}
